<template>
    <div class="example-preview table-responsive overflow-auto mt-3">
        <table class="table text-left table-hover table-bordered table-vertical-center b-table">
            <thead>
            <tr style="background-color: #472F92; color: white">
                <th>STT</th>
                <th style="min-width: 200px">Tên OKR</th>
                <th>Phòng ban</th>
                <th>Quý</th>
                <th>Phân loại</th>
                <th>Nhân sự</th>
                <th style="width: 145px">EXP đạt/ được giao</th>
                <th style="width: 150px">Người lead</th>
                <th style="width: 290px">Trạng thái</th>
                <th class="text-center" style="width:150px">Hành động</th>
            </tr>
            </thead>
            <tbody>
                <template v-if="dataOkrs?.length > 0">
                    <tr v-for="(item, index) in dataOkrs" :key="item.id">
                        <td>{{ getIndex(page, index, 20) }}</td>
                        <td>{{ item.name ?? '' }}</td>
                        <td>{{ item?.department ?? '' }}</td>
                        <td>
                            <span style="white-space: nowrap">{{ item?.fiscalQuarter }}</span>
                        </td>
                        <td>
                            <span :class="item.colorType">{{ item?.type }}</span>
                        </td>
                        <td>
                            <el-tooltip class="item" effect="dark" placement="top">
                                <template #content>
                                    <div style="display: flex; flex-direction: column; gap: 8px 0">
                                        <span v-for="item in item.humans" :key="item.id">{{item.name}}</span>
                                    </div>
                                </template>
                                <span class="text-primary" style="text-decoration: underline; cursor: pointer">{{ item?.human }}</span>
                            </el-tooltip>
                        </td>
                        <td>{{ item?.exp }}</td>
                        <td>{{ item?.leader }}</td>
                        <td :id="item.status === 6 ? 'success-okr' : item.status === 1 ? 'fail-okr' : item.status === 0 ? 'normal-okr' : 'warning-okr'">
                            <el-select v-model="item.status" :disabled="item.type === 'Cấp công ty'" placeholder="Chọn trạng thái" class="w-100" @change="updateStatusOkr(item)">
                                <el-option
                                    v-for="opt in statusOkrOption"
                                    :key="opt.value"
                                    :label="opt.label"
                                    :value="opt.value">
                                    <span :class="getStatusClass(opt.value)">{{ opt.label }}</span>
                                </el-option>
                            </el-select>
                        </td>
                        <td class="text-center">
                            <button class="btn btn-outline-warning p-0 mr-2"
                                    title="Sửa"
                                    type="button" @click="updateOkr(item)">
                                <i class="el-icon-edit-outline p-2"></i>
                            </button>
                            <button class="btn btn-outline-primary p-0 mr-2"
                                    title="Chia Exp" type="button"
                                    @click="handleShareExp(item)"><i
                                class="el-icon-pie-chart p-2"></i></button>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td colspan="11" class="text-center">Chưa có dữ liệu</td>
                    </tr>
                </template>
            </tbody>
        </table>
        <el-dialog
            class="responsive" v-if="isEdit" width="40%"
            :visible.sync="isEdit" :show-close="false"
            append-to-body :title="`Sửa okr ${okrSelected.name}`" destroy-on-close
        >
            <hr style="margin-top: -20px; border: 1px solid lightgray"/>
            <FormOKR
                @closeDialog="isEdit = false"
                @getListOkr="getListOkr"
                :okr-id="okrSelected.id"
            />
        </el-dialog>
        <el-dialog
            class="responsive" v-if="isShare" width="40%"
            :visible.sync="isShare" :show-close="false"
            append-to-body :title="`Chia EXP ${okrSelected.name}`" @close="false"
        >
            <hr style="margin-top: -20px; border: 1px solid lightgray"/>
            <TableShareExp :data-exp="okrSelected ?? []" @getListOkr="getListOkr" @closeDialog="isShare = false"/>
        </el-dialog>
    </div>
</template>

<script>

import { statusOkrOption } from "../model/OkrModel";
import { UPDATE_STATUS_OKR, UPDATE_DEADLINE_OKR } from "@/core/services/store/okrs/okr.module";
import FormOKR from "./FormOKR.vue";
import TableShareExp from "./TableShareExp.vue";


export default {
    name: 'TableOKRs',
    components: {TableShareExp, FormOKR},
    props: {
        dataOkrs: {
            type: Array,
            required: true,
            default: () => []
        },
        page: {
            type: Number,
            required: true,
            default: 1
        }
    },
    data() {
        return {
            statusOkrOption,
            isEdit: false,
            okrSelected: {},
            isShare: false,
        }
    },
    methods: {
        getIndex(page, index, limit) {
            return this.getIndexPaginate(page, index, limit)
        },
        updateOkr(okr) {
            this.isEdit = true
            this.okrSelected = okr
        },
        handleShareExp(okr) {
            this.isShare = true
            this.okrSelected = okr
        },
        updateStatusOkr(item) {
            const payload = {
                id: item.id,
                status: item.status
            }
            this.$store.dispatch(UPDATE_STATUS_OKR, payload).then(res => {
                if (!res.error) {
                    this.getListOkr()
                    this.$message.success('Cập nhật trạng thái thành công !')
                }
            }).catch(e => {
                console.log(e)
            })
        },
        updateDeadline(item) {
            if (item.deadline && +item.deadline > 100) {
                this.$message.warning('Tiến độ không được vượt quá 100%')
                return;
            }
            const payload = {
                id: item.id,
                completion_rate: item.deadline
            }
            this.$store.dispatch(UPDATE_DEADLINE_OKR, payload).then(res => {
                if (!res.error) {
                    this.getListOkr()
                    this.$message.success('Cập nhật tiến độ thành công !')
                }
            })
        },
        getListOkr() {
            this.$emit('getListOkr');
        },
        getStatusClass(status) {
            switch (status) {
                case 6:
                    return 'color-green font-weight-bold';
                case 4:
                    return 'color-warning font-weight-bold';
                case 1:
                    return 'color-red font-weight-bold';
                default:
                    return '';
            }
        }
    }
}
</script>

<style>
.color-violet {
    color: #3A057B;
}
.color-green {
    color: #16a34a !important;
}
.color-red {
    color: #dc2626 !important;
}
.color-warning {
    color: #d97706 !important;
}
#success-okr .el-input__inner {
    color: #16a34a;
    font-weight: 600;
}
#fail-okr .el-input__inner {
    color: #dc2626;
    font-weight: 600;
}
#warning-okr .el-input__inner {
    color: #d97706;
    font-weight: 600;
}
#normal-okr .el-input__inner {
    color: #374151;
}
</style>
